import React from 'react';

export default function CalendarBlockNoResults({ label }) {
  return (
    <div className="calendar-block__no-results">
      <div className="calendar-block__no-results-text">
        <p className="text text--copy">{label}</p>
      </div>
    </div>
  );
}
